var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{attrs:{"role":"button"},on:{"click":_vm.CartClick}},[_c('b-col',[_c('div',{staticClass:"Cart"},[_vm._v(" "+_vm._s(_vm.itemsQuantity)+" ")]),_c('b-icon',{staticClass:"cart-icon",attrs:{"icon":_vm.itemsQuantity > 0 ? 'cart-fill' : 'cart',"aria-hidden":"true"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }